class ApiLibrary3d {
  apiList = [
    // TODO
    // api에 snippet이 있어야 getAllFunctions에서 반환하는 "functions"에 해당 api가 포함된다.
    // 그리고 parser에서는 "functions"에 있는 함수를 호출할 때만 'WizSpritePrefix'를 붙여주어 실행가능한 함수로 만들어준다.
    // 3d 텍스트코딩 설계에 맞추려면 'getObject'와 몇몇 (오브젝트가 필요없는)함수들만 'WizSpritePrefix'가 붙도록 해줘야한다.
    {
      name: "ID_3DTEXTCODING",
      api: [
        {
          name: "getObject(title)",
          snippet: `getObject("title")`,
          selection: "title",
        },
        {
          name: "getObjectsByName(name)",
          snippet: `getObjectsByName("CUBE")`,
          selection: "CUBE",
        },
        {
          name: "goTo(x, y, z)",
          snippet: `goTo(0, 0, 0)`,
          selection: "0",
        },
        {
          name: "goX(dx)",
          snippet: `goX(1)`,
          selection: "1",
        },
        {
          name: "goY(dy)",
          snippet: `goY(1)`,
          selection: "1",
        },
        {
          name: "goZ(dz)",
          snippet: `goZ(1)`,
          selection: "1",
        },
        {
          name: "moveX(dx, speed)",
          snippet: `moveX(1, 1)`,
          selection: "1",
        },
        {
          name: "moveY(dy, speed)",
          snippet: `moveY(1, 1)`,
          selection: "1",
        },
        {
          name: "moveZ(dz, speed)",
          snippet: `moveZ(1, 1)`,
          selection: "1",
        },
        {
          name: "rotateX(dx)",
          snippet: `rotateX(90)`,
          selection: "90",
        },
        {
          name: "getPosition()",
          snippet: `getPosition()`,
        },
        {
          name: "rotateY(dy)",
          snippet: `rotateY(90)`,
          selection: "90",
        },
        {
          name: "rotateZ(dz)",
          snippet: `rotateZ(90)`,
          selection: "90",
        },
        {
          name: "turnX(dx, speed)",
          snippet: `turnX(90, 90)`,
          selection: "90",
        },
        {
          name: "turnY(dy, speed)",
          snippet: `turnY(90, 90)`,
          selection: "90",
        },
        {
          name: "turnZ(dz, speed)",
          snippet: `turnZ(90, 90)`,
          selection: "90",
        },
        // {
        //   name: "setRotation(x, y, z)",
        //   snippet: `setRotation(0, 0, 0)`,
        // },
        {
          name: "getRotation()",
          snippet: `getRotation()`,
        },
        // {
        //   name: "faceTo(target, yawOnly)",
        //   snippet: `faceTo("title", false)`,
        //   selection: "title",
        // },
        {
          name: "onCollide(target, callback)",
          snippet: `onCollide("title", function() {})`,
          newLine: `onCollide("title", function() {`,
          selection: "title",
        },
        {
          name: "onCollideOnce(target, callback)",
          snippet: `onCollideOnce("title", function() {})`,
          newLine: `onCollideOnce("title", function() {`,
          selection: "title",
        },
        {
          name: "onContact(target, callback)",
          snippet: `onContact("title", function() {})`,
          newLine: `onContact("title", function() {`,
          selection: "title",
        },
        {
          name: "onCollideEnd(target, callback)",
          snippet: `onCollideEnd("title", function() {})`,
          newLine: `onCollideEnd("title", function() {`,
          selection: "title",
        },
        // {
        //   name: "onCollideTag(callbacks)",
        //   snippet: `onCollideTag({})`,
        //   newLine: `onCollideTag({`,
        // },
        {
          name: "onClick(callback)",
          snippet: `onClick(function() {})`,
          newLine: `onClick(function() {`,
        },
        {
          name: "kill()",
          snippet: `kill()`,
        },
        {
          name: "revive()",
          snippet: `revive()`,
        },
        {
          name: "onSecond(sec, callback)",
          snippet: `onSecond(1, function() {})`,
          newLine: `onSecond(1, function() {`,
          selection: "1",
        },
        {
          name: "wait(sec)",
          snippet: `wait(1)`,
          selection: "1",
        },
        {
          name: "spawn()",
          snippet: `spawn()`,
        },
        {
          name: "playAnimation(mode)",
          snippet: `playAnimation("mode")`,
          selection: "mode",
        },
        {
          name: "changePlayerSpeed(speed)",
          snippet: `changePlayerSpeed(1)`,
          selection: "1",
        },
        {
          name: "changeAxisSpeed(x, y, z)",
          snippet: `changeAxisSpeed(0, 0, 0)`,
          selection: "0",
        },
        {
          name: "changeAvatar(modelInfo)",
          snippet: `changeAvatar("modelInfo")`,
          selection: "modelInfo",
        },
        {
          name: "sendSignal(signal, params)",
          snippet: `sendSignal("signal", {})`,
          selection: "signal",
        },
        {
          name: "onSignal(signal, callback)",
          snippet: `onSignal("signal", function(params) {})`,
          newLine: `onSignal("signal", function(params) {`,
          selection: "signal",
        },
        {
          name: "onJoin(callback)",
          snippet: `onJoin(function(id) {})`,
          newLine: `onJoin(function(id) {`,
        },
        {
          name: "onLeave(callback)",
          snippet: `onLeave(function(id) {})`,
          newLine: `onLeave(function(id) {`,
        },
        {
          name: "onKeyDown(code, callback)",
          snippet: `onKeyDown("KeyZ", function() {})`,
          newLine: `onKeyDown("KeyZ", function() {`,
          selection: "KeyZ",
        },
        {
          name: "onKeyUp(code, callback)",
          snippet: `onKeyUp("KeyZ", function() {})`,
          newLine: `onKeyUp("KeyZ", function() {`,
          selection: "KeyZ",
        },
        {
          name: "onClickEmpty(callback)",
          snippet: `onClickEmpty(function () {})`,
          newLine: `onClickEmpty(function () {`,
        },
        {
          name: "startTimer()",
          snippet: `startTimer()`,
        },
        {
          name: "pauseTimer()",
          snippet: `pauseTimer()`,
        },
        {
          name: "resumeTimer()",
          snippet: `resumeTimer()`,
        },
        {
          name: "resetTimer()",
          snippet: `resetTimer()`,
        },
        {
          name: "getTimer()",
          snippet: `getTimer()`,
        },
        {
          name: "setText(text)",
          snippet: `setText("text")`,
          selection: "text",
        },
        {
          name: "setTextSize(size)",
          snippet: `setTextSize(10)`,
          selection: "10",
        },
        {
          name: "show()",
          snippet: `show()`,
        },
        {
          name: "hide()",
          snippet: `hide()`,
        },
        {
          name: "setOpacity(opacity)",
          snippet: "setOpacity(1)",
        },
        {
          name: "setPosition(x, y)",
          snippet: `setPosition(0, 0)`,
          selection: "0",
        },
        {
          name: "setScale(x, y)",
          snippet: `setScale(100, 100)`,
          selection: "100",
        },
        {
          name: "move(dx, dy, speed)",
          snippet: `move(100, 100, 100)`,
          selection: "100",
        },
        {
          name: "playAudio()",
          snippet: `playAudio()`,
        },
        {
          name: "pauseAudio()",
          snippet: `pauseAudio()`,
        },
        {
          name: "stopAudio()",
          snippet: `stopAudio()`,
        },
        {
          name: "setVolume(volume)",
          snippet: `setVolume(1)`,
          selection: "1",
        },
        {
          name: "setPlaybackRate(playbackRate)",
          snippet: `setPlaybackRate(1)`,
          selection: "1",
        },
        {
          name: "getVolume()",
          snippet: `getVolume()`,
        },
        {
          name: "playVideo()",
          snippet: "playVideo()",
        },
        {
          name: "pauseVideo()",
          snippet: "pauseVideo()",
        },
        {
          name: "emit(life)",
          snippet: `emit(1)`,
          selection: "1",
        },
        {
          name: "stopEmit()",
          snippet: `stopEmit()`,
        },
        {
          name: "changeScene(pId)",
          snippet: `changeScene("pId")`,
          selection: "pId",
        },
        {
          name: "stopAllSound()",
          snippet: `stopAllSound()`,
        },
        {
          name: "getMousePosition()",
          snippet: `getMousePosition()`,
        },
        {
          name: "enableKeyControl()",
          snippet: `enableKeyControl(true)`,
        },
        {
          name: "enableJoystickControl()",
          snippet: `enableJoystickControl(true)`,
        },
        {
          name: "hideAllGui()",
          snippet: `hideAllGui()`,
        },
        {
          name: "getPlayerCount()",
          snippet: `getPlayerCount()`,
        },
        {
          name: "sendGameEvent()",
          snippet: `sendGameEvent()`,
        },
        {
          name: "onReduxMessage()",
          snippet: `onReduxMessage()`,
        },
        // Ad
        {
          name: "showAd()",
          snippet: "showAd()",
        },
        {
          name: "hideAd()",
          snippet: "hideAd()",
        },
        {
          name: "onClickAdBanner()",
          snippet: "onClickAdBanner()",
        },
        // Date Apis
        {
          name: "getYear()",
          snippet: `getYear()`,
        },
        {
          name: "getMonth()",
          snippet: `getMonth()`,
        },
        {
          name: "getDay()",
          snippet: `getDay()`,
        },
        {
          name: "getHour()",
          snippet: `getHour()`,
        },
        {
          name: "getMinutes()",
          snippet: `getMinutes()`,
        },
        {
          name: "getSeconds()",
          snippet: `getSeconds()`,
        },
        // Math Operation
        {
          name: "abs(number)",
          snippet: `abs(1)`,
          selection: "1",
        },
        {
          name: "round(number, digit)",
          snippet: `round(1)`,
          selection: "1",
        },
        {
          name: "ceil(number, digit)",
          snippet: `ceil(1)`,
          selection: "1",
        },
        {
          name: "floor(number, digit)",
          snippet: `floor(1)`,
          selection: "1",
        },
        {
          name: "pow(number, exponent)",
          snippet: `pow(1, 1)`,
          selection: "1",
        },
        {
          name: "sqrt(number)",
          snippet: `sqrt(1)`,
          selection: "1",
        },
        {
          name: "log(number, base)",
          snippet: `log(1)`,
          selection: "1",
        },
        {
          name: "getRandom(min, max)",
          snippet: `getRandom(0, 1)`,
          selection: "0",
        },
        {
          name: "setShadow(boolean)",
          snippet: `setShadow(true)`,
          selection: "true",
        },
        {
          name: "takeShadow(boolean)",
          snippet: `takeShadow(true)`,
          selection: "true",
        },
        {
          name: "findFirstAncestor()",
          snippet: `findFirstAncestor()`,
        },
        {
          name: "findFirstChild()",
          snippet: `findFirstChild()`,
        },
        {
          name: "setMovable(true)",
          snippet: `setMovable(true)`,
          selection: "true",
        },
        {
          name: "applyForce(x, y, z)",
          snippet: `applyForce(100, 100, 100)`,
          selection: "100",
        },
        {
          name: "setTextureOffset(x, y)",
          snippet: `setTextureOffset(0, 0)`,
          selection: "0",
        },
        // {
        //   name: "setTag(tag)",
        //   snippet: `setTag("tag")`,
        //   selection: "tag",
        // },
        // {
        //   name: "removeTag()",
        //   snippet: `removeTag()`,
        // },
        // Detection Apis
        {
          name: "isKeyDown(code)",
          snippet: `isKeyDown("KeyA")`,
          selection: "keyA",
        },
        {
          name: "isMouseDown()",
          snippet: `isMouseDown()`,
        },
        {
          name: "isMouseDownObject(title)",
          snippet: `isMouseDownObject("title")`,
          selection: "title",
        },
        // Background Apis
        {
          name: "changeBackground(title)",
          snippet: `changeBackground("glorious_pink")`,
          selection: "glorious_pink",
        },
        {
          name: "changeBackgroundColor(color)",
          snippet: `changeBackgroundColor(0x000000)`,
          selection: "0x000000",
        },
        {
          name: "setCameraProperty(fov, near, far)",
          snippet: `setCameraProperty(50, 1, 1000)`,
          selection: "50",
        },
        {
          name: "setZoomRange(min, max)",
          snippet: `setZoomRange(10, 50)`,
          selection: "10",
        },
        {
          name: "playFocus(target)",
          snippet: "playFocus()",
        },
        {
          name: "fadeObstacle(boolean)",
          snippet: "fadeObstacle",
        },
      ],
      //new API LIST need to check compatability with old version
    },
  ];
  apiNewList = [
    {
      name: "ID_3DTEXTCODING",
      api: [
        {
          name: "getObject(title)",
          snippet: `getObject("title")`,
          selection: "title",
        },
        {
          name: "go(dx, dy, dz)",
          snippet: `goTo(0, 0, 0)`,
          selection: "0",
        },
        {
          name: "move(dx, dy, dz, duration)",
          snippet: `move(0, 0, 0, 0)`,
          selection: "0",
        },
        {
          name: "rotate(dx, dy, dz)",
          snippet: `rotate(0, 0, 0)`,
          selection: "0",
        },
        {
          name: "turn(dx, dy, dz, duration)",
          snippet: `turn(0, 0, 0, 0)`,
          selection: "0",
        },
        {
          name: "onCollide(target, callback)",
          snippet: `onCollide(target, function() {})`,
          newLine: `onCollide(target, function() {`,
          selection: "target",
        },
        {
          name: "applyForce(x, y ,z)",
          snippet: "applyForce(0, 0, 0)",
          selection: "0",
        },
        {
          name: "onClick(callback)",
          snippet: `onClick(function() {})`,
          newLine: `onClick(function() {`,
        },
        {
          name: "kill()",
          snippet: `kill()`,
        },
        {
          name: "cloneWithMethods()",
          snippet: `cloneWithMethods()`,
        },
        {
          name: "revive()",
          snippet: `revive()`,
        },
        {
          name: "getAudio()",
          snippet: `getAudio()`,
        },
        {
          name: "spawn()",
          snippet: `spawn()`,
        },
        {
          name: "changePlayerSpeed(speed)",
          snippet: `changePlayerSpeed(1)`,
          selection: "1",
        },
        {
          name: "changePlayerJumpHeight(height)",
          snippet: `changePlayerJumpHeight(3)`,
          selection: "3",
        },
        {
          name: "changeAxisSpeed(x, y, z)",
          snippet: `changeAxisSpeed(0, 0, 0)`,
          selection: "0",
        },
        {
          name: "send(signal, params)",
          snippet: `send("signal", params)`,
          selection: "signal",
        },
        {
          name: "addListener(signal, callback)",
          snippet: `addListener("signal", function(params) {})`,
          newLine: `addListener("signal", function(params) {`,
          selection: "signal",
        },
        {
          name: "removeListener(signal, callback)",
          snippet: `removeListener("signal", function(params) {})`,
          newLine: `removeListener("signal", function(params) {`,
          selection: "signal",
        },
        {
          name: "OnKeyDown(event){}",
          snippet: `OnKeyDown(event){}`,
          newLine: `OnKeyDown(event) {`,
        },
        {
          name: "OnKeyUp(event){}",
          snippet: `OnKeyUp(event){}`,
          newLine: `OnKeyUp(event) {`,
        },
        {
          name: "start()",
          snippet: `start()`,
        },
        {
          name: "pause()",
          snippet: `pause()`,
        },
        {
          name: "resume()",
          snippet: `resume()`,
        },
        {
          name: "reset()",
          snippet: `reset()`,
        },
        {
          name: "getTime()",
          snippet: `getTime()`,
        },
        {
          name: "setText(text)",
          snippet: `setText("text")`,
          selection: "text",
        },
        {
          name: "setTextSize(size)",
          snippet: `setTextSize(10)`,
          selection: "10",
        },
        {
          name: "show()",
          snippet: `show()`,
        },
        {
          name: "hide()",
          snippet: `hide()`,
        },
        // Date Apis
        {
          name: "getYear()",
          snippet: `getYear()`,
        },
        {
          name: "getMonth()",
          snippet: `getMonth()`,
        },
        {
          name: "getDay()",
          snippet: `getDay()`,
        },
        {
          name: "getHour()",
          snippet: `getHour()`,
        },
        {
          name: "getMinutes()",
          snippet: `getMinutes()`,
        },
        {
          name: "getSeconds()",
          snippet: `getSeconds()`,
        },
        // Math Operation
        {
          name: "abs(number)",
          snippet: `abs(1)`,
          selection: "1",
        },
        {
          name: "round(number, digit)",
          snippet: `round(1)`,
          selection: "1",
        },
        {
          name: "ceil(number, digit)",
          snippet: `ceil(1)`,
          selection: "1",
        },
        {
          name: "floor(number, digit)",
          snippet: `floor(1)`,
          selection: "1",
        },
        {
          name: "pow(number, exponent)",
          snippet: `pow(1, 1)`,
          selection: "1",
        },
        {
          name: "sqrt(number)",
          snippet: `sqrt(1)`,
          selection: "1",
        },
        {
          name: "log(number, base)",
          snippet: `log(1)`,
          selection: "1",
        },
        {
          name: "getRandom(min, max)",
          snippet: `getRandom(0, 1)`,
          selection: "0",
        },
        {
          name: "add(object)",
          snippet: "add({})",
          selection: "{}",
        },
        {
          name: "attach(object)",
          snippet: "attach({})",
          selection: "{}",
        },
        {
          name: "remove(object)",
          snippet: "remove({})",
          selection: "{}",
        },
        {
          name: "removeFromParent()",
          snippet: "removeFromParent()",
        },
        {
          name: "clone(recursive)",
          snippet: "clone(true)",
          selection: "true",
        },
        {
          name: "copy(object, recursive)",
          snippet: "copy({}, true)",
          selection: "{}",
        },
        {
          name: "getObjectByProperty(name, value)",
          snippet: 'getObjectByProperty("name", "value")',
          selection: '"name"',
        },
        {
          name: "getObjectById(id)",
          snippet: "getObjectById(0)",
          selection: "0",
        },
        {
          name: "getWorldPosition(target)",
          snippet: "getWorldPosition({})",
          selection: "{}",
        },
        {
          name: "getWorldQuaternion(target)",
          snippet: "getWorldQuaternion({})",
          selection: "{}",
        },
        {
          name: "getWorldScale(target)",
          snippet: "getWorldScale({})",
          selection: "{}",
        },
        {
          name: "getWorldDirection(target)",
          snippet: "getWorldDirection({})",
          selection: "{}",
        },
        {
          name: "rotateOnAxis(axis, angle)",
          snippet: "rotateOnAxis({}, 0)",
          selection: "{}",
        },
        {
          name: "rotateOnWorldAxis(axis, angle)",
          snippet: "rotateOnWorldAxis({}, 0)",
          selection: "{}",
        },
        {
          name: "traverse(callback)",
          snippet: "traverse(function() {})",
          newLine: "traverse(function() {",
        },
        {
          name: "lookAt(x, y, z)",
          snippet: "lookAt(0, 0, 0)",
          selection: "0",
        },
        {
          name: "raycast(raycaster, intersects)",
          snippet: "raycast({}, [])",
          selection: "{}",
        },
        {
          name: "updateProjectionMatrix()",
          snippet: "updateProjectionMatrix()",
        },
        {
          name: "play(delay)",
          snippet: "play(0)",
          selection: "0",
        },
        {
          name: "pause()",
          snippet: "pause()",
        },
        {
          name: "setPlaybackRate(value)",
          snippet: "setPlaybackRate(1.0)",
          selection: "1.0",
        },
        {
          name: "setVolume(value)",
          snippet: "setVolume(1.0)",
          selection: "1.0",
        },
        {
          name: "stop()",
          snippet: "stop()",
        },
        {
          name: "forEach(callback)",
          snippet: "forEach(function(item) {})",
          newLine: "forEach(function(item) {",
          selection: "item",
        },
        {
          name: "setTimeout(callback, delay)",
          snippet: "setTimeout(function() {}, 1000)",
          newLine: "setTimeout(function() {",
          selection: "1000",
        },
        {
          name: "setInterval(callback, interval)",
          snippet: "setInterval(function() {}, 1000)",
          newLine: "setInterval(function() {",
          selection: "1000",
        },
        //Math
        {
          name: "Math.abs(x)",
          snippet: "abs(x)",
          selection: "x",
        },
        {
          name: "Math.ceil(x)",
          snippet: "ceil(x)",
          selection: "x",
        },
        {
          name: "Math.floor(x)",
          snippet: "Math.floor(x)",
          selection: "x",
        },
        {
          name: "Math.round(x)",
          snippet: "round(x)",
          selection: "x",
        },
        {
          name: "Math.max(x, y, ...)",
          snippet: "max(x, y)",
          selection: "x",
        },
        {
          name: "Math.min(x, y, ...)",
          snippet: "min(x, y)",
          selection: "x",
        },
        {
          name: "Math.pow(x, y)",
          snippet: "pow(x, y)",
          selection: "x",
        },
        {
          name: "Math.sqrt(x)",
          snippet: "sqrt(x)",
          selection: "x",
        },
        {
          name: "Math.random()",
          snippet: "random()",
        },
        {
          name: "Math.sin(x)",
          snippet: "sin(x)",
          selection: "x",
        },
        {
          name: "Math.cos(x)",
          snippet: "cos(x)",
          selection: "x",
        },
        {
          name: "Math.tan(x)",
          snippet: "tan(x)",
          selection: "x",
        },
        {
          name: "Math.asin(x)",
          snippet: "asin(x)",
          selection: "x",
        },
        {
          name: "Math.acos(x)",
          snippet: "acos(x)",
          selection: "x",
        },
        {
          name: "Math.atan(x)",
          snippet: "atan(x)",
          selection: "x",
        },
        {
          name: "Math.atan2(y, x)",
          snippet: "atan2(y, x)",
          selection: "y",
        },
        {
          name: "Math.exp(x)",
          snippet: "exp(x)",
          selection: "x",
        },
        {
          name: "Math.log(x)",
          snippet: "log(x)",
          selection: "x",
        },
        {
          name: "Math.log10(x)",
          snippet: "log10(x)",
          selection: "x",
        },
        //common functions
        {
          name: "setFollowingCamera(camera)",
          snippet: "setFollowingCamera(camera)",
          selection: "camera",
        },
        {
          name: "activate()",
          snippet: "activate()",
        },
        {
          name: "setDefaultController()",
          snippet: "setDefaultController()",
        },
        {
          name: "createDefaultAvatar()",
          snippet: "createDefaultAvatar()",
        },
        {
          name: "useVR({ VRObject: object })",
          snippet: "useVR({ VRObject: object })",
          selection: "object",
        },
        {
          name: "useFPS()",
          snippet: "useFPS()",
        },
        {
          name: "useTPV()",
          snippet: "useTPV()",
        },
        {
          name: "visible = true;",
          snippet: "visible = true;",
          selection: "true",
        },
        //Tween
        {
          name: "onUpdate(callback)",
          snippet: "onUpdate(function(){})",
          newLine: `onUpdate(function(){`,
        },
        {
          name: "easing(TWEEN.Easing.Quadratic.InOut)",
          snippet: "easing(TWEEN.Easing.Quadratic.InOut)",
          selection: "Quadratic.InOut",
        },
        {
          name: "onComplete(callback)",
          snippet: "onComplete(function(){})",
          newLine: `onComplete(function(){`,
        },
        {
          name: "onStart(callback)",
          snippet: "onStart(function(){})",
          newLine: `onStart(function(){`,
        },

        //class
        {
          name: "class",
          snippet: "class Something{}",
          newLine: `class Something{`,
          selection: "Something",
        },
        {
          name: "constructor(){}",
          snippet: "constructor(){}",
          newLine: `constructor(){`,
        },
        //console
        {
          name: "console.log(value)",
          snippet: "console.log(value);",
          selection: "value",
        },
      ],
    },
  ];

  getAllFunctions() {
    let functions = [];

    this.apiList.forEach(category => {
      const categoryName = category.name;
      if (categoryName === "ID_3DTEXTCODING") {
        // [TMP] 이외의 api들(기존에 있던 것들)은 대부분 삭제/재조정 필요
        category.api.forEach(api => {
          if (api.snippet) {
            if (api.name === "if / else / else if") {
              return;
            }
            // const meta = categoryName;
            const meta = "function";
            const caption = api.name;
            const value = api.snippet;
            const newLine = api.newLine;
            const selection = api.selection;
            const selectionType = api.selectionType;
            const requiredParamCount = api.requiredParamCount;
            const tip = api.tip;
            const funcRegex = /([a-zA-Z_{1}][a-zA-Z0-9_]+)(?=\()/gim;
            const funcMatch = funcRegex.exec(api.name);
            let name;
            if (funcMatch) name = funcMatch[0];
            functions.push({
              name,
              tip,
              caption,
              value,
              meta,
              newLine,
              selection,
              selectionType,
              requiredParamCount,
            });
          }
        });
      }
    });

    functions.push({
      caption: "if",
      value: `if(true){}`,
      meta: "conditional",
      newLine: `if(true){`,
      selection: "true",
    });
    functions.push({
      caption: "else if",
      value: `else if(true){}`,
      meta: "conditional",
      newLine: `else if(true){`,
      selection: "true",
    });
    functions.push({
      caption: "else",
      value: `else{}`,
      meta: "conditional",
      newLine: `else{`,
    });
    functions.push({
      caption: "true",
      value: `true`,
      meta: "boolean",
    });
    functions.push({
      caption: "false",
      value: `false`,
      meta: "boolean",
    });
    functions.push({
      caption: "switch~case",
      value: `switch(value){}`,
      meta: "conditional",
      newLine: `switch(value){`,
      selection: "value",
    });
    functions.push({
      caption: "for",
      value: `for(let i=0; i<10; i++){}`,
      meta: "loop",
      newLine: `for(let i=0; i<10; i++){`,
      selection: "10",
    });
    functions.push({
      caption: "while",
      value: `while(true){}`,
      meta: "loop",
      newLine: `while(true){`,
      selection: "true",
    });
    functions.push({
      caption: "let",
      value: `let`,
      meta: "variable",
    });
    functions.push({
      caption: "const",
      value: `const`,
      meta: "variable",
    });
    functions.push({
      caption: "var",
      value: `var`,
      meta: "variable",
    });

    return functions;
  }
  getNewAllFunctions() {
    let functions = [];

    this.apiNewList.forEach(category => {
      const categoryName = category.name;
      if (categoryName === "ID_3DTEXTCODING") {
        // [TMP] 이외의 api들(기존에 있던 것들)은 대부분 삭제/재조정 필요
        category.api.forEach(api => {
          if (api.snippet) {
            if (api.name === "if / else / else if") {
              return;
            }
            // const meta = categoryName;
            const meta = "function";
            const caption = api.name;
            const value = api.snippet;
            const newLine = api.newLine;
            const selection = api.selection;
            const selectionType = api.selectionType;
            const requiredParamCount = api.requiredParamCount;
            const tip = api.tip;
            const funcRegex = /([a-zA-Z_{1}][a-zA-Z0-9_]+)(?=\()/gim;
            const funcMatch = funcRegex.exec(api.name);
            let name;
            if (funcMatch) name = funcMatch[0];
            functions.push({
              name,
              tip,
              caption,
              value,
              meta,
              newLine,
              selection,
              selectionType,
              requiredParamCount,
            });
          }
        });
      }
    });

    functions.push({
      caption: "if",
      value: `if(true){}`,
      meta: "conditional",
      newLine: `if(true){`,
      selection: "true",
    });
    functions.push({
      caption: "else if",
      value: `else if(true){}`,
      meta: "conditional",
      newLine: `else if(true){`,
      selection: "true",
    });
    functions.push({
      caption: "else",
      value: `else{}`,
      meta: "conditional",
      newLine: `else{`,
    });
    functions.push({
      caption: "true",
      value: `true`,
      meta: "boolean",
    });
    functions.push({
      caption: "false",
      value: `false`,
      meta: "boolean",
    });
    functions.push({
      caption: "switch~case",
      value: `switch(value){}`,
      meta: "conditional",
      newLine: `switch(value){`,
      selection: "value",
    });
    functions.push({
      caption: "for",
      value: `for(let i=0; i<10; i++){}`,
      meta: "loop",
      newLine: `for(let i=0; i<10; i++){`,
      selection: "10",
    });
    functions.push({
      caption: "while",
      value: `while(true){}`,
      meta: "loop",
      newLine: `while(true){`,
      selection: "true",
    });
    functions.push({
      caption: "let",
      value: `let`,
      meta: "variable",
    });
    functions.push({
      caption: "const",
      value: `const`,
      meta: "variable",
    });
    functions.push({
      caption: "var",
      value: `var`,
      meta: "variable",
    });

    return functions;
  }
}

export default new ApiLibrary3d();
